export enum AccountType {
    FullAccount = 'full',
    Trial = 'trial',
  }
